import type { ReactNode } from 'react';

const CELL_CLASS =
  'border-b border-r border-solid border-gray-200 last:border-r-0';
const HEADER_CELL_CLASS = `${CELL_CLASS} px-3 py-2.5`;

type EnvVarTableProps = {
  headers: Array<{ label: string; center?: boolean; className?: string }>;
  children: ReactNode;
};

export const EnvVarTable = ({ headers, children }: EnvVarTableProps) => (
  <div className="overflow-hidden rounded-lg border border-gray-200 border-solid">
    <table className="w-full border-collapse font-mono text-sm">
      <thead>
        <tr className="bg-gray-50 text-left font-sans text-muted-foreground text-xs">
          {headers.map(h => (
            <th
              className={[
                HEADER_CELL_CLASS,
                h.center ? 'text-center' : '',
                h.className ?? ''
              ]
                .filter(Boolean)
                .join(' ')}
              key={h.label}
            >
              {h.label}
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="[&>tr:last-child>td]:border-b-0">{children}</tbody>
    </table>
  </div>
);

type EnvVarCellProps = {
  children: ReactNode;
  className?: string;
};

export const EnvVarCell = ({ children, className = '' }: EnvVarCellProps) => (
  <td className={`${CELL_CLASS} ${className}`}>{children}</td>
);

type EnvVarCellChildrenProps = {
  children: ReactNode;
};

export const EnvVarCellText = ({ children }: EnvVarCellChildrenProps) => (
  <td className={`${CELL_CLASS} px-3 py-2.5 font-mono`}>{children}</td>
);

export const EnvVarCellMuted = ({ children }: EnvVarCellChildrenProps) => (
  <td className={`${CELL_CLASS} px-3 py-2.5 text-muted-foreground`}>
    {children}
  </td>
);

export const EnvVarCellCenter = ({ children }: EnvVarCellChildrenProps) => (
  <td className={`${CELL_CLASS} p-0`}>
    <div className="flex h-10 items-center justify-center">{children}</div>
  </td>
);

export const EnvVarCellInput = ({ children }: EnvVarCellChildrenProps) => (
  <td className={`${CELL_CLASS} relative p-0`}>{children}</td>
);
